import WorkspaceMembership from "./workspace-membership";
import {setWorkspace, setWorkspaceMembership, setWorkspaceMemberships} from "../../system/app-slice";
import {useState} from "react";
import {useDispatch, useSelector} from "react-redux";

export default function useWorkspaceMembership() {
    const [loading, setLoading] = useState(false);
    const {user} = useSelector(state => state.auth);
    const dispatch = useDispatch();

    const getWorkspaceMemberships = async ()=>{
        setLoading(true)
        const workspaceMembership = new WorkspaceMembership();
        try {
            const query = {
                filters: {
                    $and:[
                        {member:{$eq: user.id}},
                        // {members: {id:{$eq: user.id}}}
                    ],
                },
                populate:{
                    "member":true,
                    "user_roles": {
                        filters:{
                            $and:[
                                {user:{$in:[user.id]}}
                            ]},
                        populate:{"user":{populate:["profileImage"]}}},
                    "workspace":{populate:{
                            "goals": {
                                filters:{
                                    $and:[
                                        {archivedAt:{$null:true}},
                                        // {
                                        //     $or: [
                                        //         {owner: {$eq: user.id}},
                                        //         // {members: {$in: [user.id]}},
                                        //         {workspace: {
                                        //                 user_roles: {
                                        //                     $and:[
                                        //                         {user:{$eq:user.id}},
                                        //                         {role:{$eq:"owner"}}
                                        //                     ]
                                        //                 }
                                        //             }},
                                        //         // {team: {members: {$in: [user.id]}}},
                                        //     ]
                                        // }
                                    ]
                                },
                                populate:{parentGoal:{filters:{$and:[{archivedAt:{$null:true}}]}}, "owner":{populate:["profileImage"]}, "team":true},

                                },
                            "projects": {
                                populate:{
                                    "attachments": {populate:"*"},
                                    "deliverables": {populate: {
                                        "owner":{populate:["profileImage"]},
                                        "assignee":{populate:["profileImage"]},
                                        "project": {
                                            populate:{owner: true},
                                        },
                                        "attachments":true
                                    }},
                                    "goals": {
                                        populate:{owner: true},
                                        filters:{$and:[{archivedAt:{$null:true}}]}},
                                    "members": {populate: {member:{populate:["profileImage"]}}},
                                    "owner":{populate:["profileImage"]},
                                    "tasks": {
                                        populate:{assignee: true},
                                        filters:{$and:[{archivedAt:{$null:true}}]}
                                    },
                                    "portfolios":{populate: ["owner"]},
                                    "team": {
                                        populate:{owner: true},
                                    }

                            },
                                filters:{
                                    $and:[
                                        {archivedAt:{$null:true}},
                                        {
                                            $or: [
                                                {owner: {$eq: user.id}},
                                                {members: {member:{$eq:user.id}}},
                                                {workspace: {
                                                        user_roles: {
                                                            $and:[
                                                                {user:{$eq:user.id}},
                                                                {role:{$eq:"owner"}}
                                                            ]
                                                        }
                                                    }},
                                                // {team: {members: {$in: [user.id]}}},
                                            ]
                                        }
                                    ]
                                }
                            },
                            "task_types":true,
                            "subscriptions":true,
                            "workspace_memberships": {populate:{"user_roles": {fields:["role", "scope_id", "scope_type"]},"member":{populate:["profileImage"]}}},
                            "teams": {
                                populate:{owner: true},
                            }
                        }
                    }
                }
            }
            const _data = await workspaceMembership.getAll(query);
            const _workspaceMemberships = _data?.data;
            const _defaultWorkspaceMembership = _workspaceMemberships.find(e=>e.isDefault);
            dispatch(setWorkspaceMemberships(_workspaceMemberships));
            dispatch(setWorkspaceMembership((_defaultWorkspaceMembership)));
            console.log(_defaultWorkspaceMembership)

            if (_defaultWorkspaceMembership){
                dispatch(setWorkspace(_defaultWorkspaceMembership?.workspace?.documentId))
            }
            setLoading(false)
            return _data;
        }catch (e) {
            setLoading(false)
        }
    }

    const updateDefaultWorkspaceMembership=async (documentId)=>{
        const workspaceMembership = new WorkspaceMembership();
        try {
            await workspaceMembership.updateItem(documentId, {isDefault:true});
            const _data = await getWorkspaceMemberships();
            return _data;
        }catch (e) {

        }
    }

    const deleteWorkspaceMemberShip = async (documentId)=>{
        const workspaceMembership = new WorkspaceMembership();
        try {
            await workspaceMembership.deleteItem(documentId);
            const _data = await getWorkspaceMemberships();
            return _data;
        }catch (e) {

        }
    }

    return {getWorkspaceMemberships, updateDefaultWorkspaceMembership, deleteWorkspaceMemberShip, loading};
}

